import { NavLink, useLocation } from 'react-router-dom'
import NavigatorMenuItems from './NavigatorMenuItems'
import LoginBtnModal from 'components/Login/loginBtnModal'

const NavigatorMenu = () => {
  const { pathname } = useLocation()

  return (
    <nav className="main-menu navbar-expand-md">
      <div className="navbar-header">
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>
      </div>

      <div className="navbar-collapse collapse clearfix" id="navbarSupportedContent">
        <NavigatorMenuItems />
      </div>

      <div className="outer-box clearfix">
        <div className="btn-box">
          <LoginBtnModal />
        </div>
      </div>
    </nav>
  )
}

export default NavigatorMenu
